<ng-container *ngIf="onlyBalance">
  <div class="only-balance" *ngIf="currentCurrencyData">
    <img class="currency-icon" [src]="currentCurrencyData.icon" />
    <span #amount>
      {{
        allCurrencyBalance
          | filterByKeyValue: 'currency' : currentCurrencyData.currency : 'balance'
          | currencyValue: currentCurrencyData.currency || ''
      }}
    </span>
  </div>
</ng-container>

<div class="currency-wallet" *ngIf="!onlyBalance">
  <app-currency-wallet-expansion
    [checkedItem]="currentCurrencyData?.currency || ''"
    [isDiasbled]="isDiasbled"
    (selectItemHeader)="receiveSelectItemHeader($event)"
  >
    <div class="expansion-row" content>
      <div class="contants-row mutual-opacity onact96">
        <!--用户金额-->
        <div class="amount">
          <ng-container *ngIf="currentCurrencyData">
            <ng-container *ngIf="!isShowPlaying">
              <div class="amount-currency">
                <img class="currency-icon" [src]="currentCurrencyData.icon" />
                <span class="currency-flag">{{ currentCurrencyData.currency }}</span>
                <i class="icon-arrow-down-simple"></i>
              </div>
              <span #amount class="amount-number">
                <ng-container
                  *ngTemplateOutlet="
                    topAmountValue;
                    context: {
                      conversionCurrencyData: currencyWalletService.conversionCurrency$ | async,
                      currency: currentCurrencyData.currency,
                      balance:
                        allCurrencyBalance
                        | filterByKeyValue: 'currency' : currentCurrencyData.currency : 'nonStickyBalance'
                    }
                  "
                ></ng-container>
              </span>
            </ng-container>
            <ng-container *ngIf="isShowPlaying">
              <span class="play-in">({{ 'play_in' | translate }})</span>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="toggle mutual-opacity onact96" (click)="toDeposit($event)">
        <i class="icon-top-wallet"></i>
        <span class="toggle-wallet">{{ 'deposit' | translate }}</span>
      </div>
    </div>
  </app-currency-wallet-expansion>
</div>

<!-- 顶部币值显示 -->
<ng-template
  #topAmountValue
  let-conversionCurrencyData="conversionCurrencyData"
  let-currency="currency"
  let-balance="balance"
>
  <ng-container *ngIf="conversionCurrencyData.enable">
    <ng-container>
      {{ conversionCurrencyData?.currency?.symbol || '' }}
      {{
        conversionCurrencyData.rate.length > 0
          ? (currencyWalletService.amountAfterCalculateRate(balance, currency)
            | currencyValue: conversionCurrencyData.currency.currency)
          : '0.00'
      }}
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!conversionCurrencyData.enable">
    {{ balance | currencyValue: currency }}
  </ng-container>
</ng-template>
